import script from "./CustomNumberField.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomNumberField.vue?vue&type=script&lang=ts&setup=true"

import "./CustomNumberField.vue?vue&type=style&index=0&id=2c00750d&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c00750d"]])

export default __exports__